module.exports = __webpack_public_path__ + "img/image.92bfcc08.svg";